import React, { useState, useEffect } from "react";
import FbxModel from "../FbxModel";
import "./ModelPage.css";
import MapPrompt from "../MapPrompt";

function ModelPage() {
  const [showTips, setShowTips] = useState({
    smartLock: false,
    smokeAlarm: false,
    securityCamera: false,
  });

  const [showMapPrompt, setShowMapPrompt] = useState(false);

  const toggleTips = (device) => {
    setShowTips((prev) => ({
      ...prev,
      [device]: !prev[device],
    }));
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowMapPrompt(true);
    }, 10000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="model-page-container">
      <div className="device-sidebar">
        <h3>Safety Devices</h3>
        <h5>Click on a device name to see more information.</h5>
        <ul className="device-list">
          <li className="device-item">
            <div
              onClick={() => toggleTips("smartLock")}
              className="device-toggle"
            >
              <div className="device-name">
                <span
                  className="device-icon"
                  style={{ backgroundColor: "#ff0000" }}
                ></span>
                <span>Smart Lock</span>
              </div>
              {showTips.smartLock ? "^" : "v"}
            </div>
            {showTips.smartLock && (
              <p className="device-description">
                Install on your main door to prevent unauthorized entry.
                Consider installing additional smart locks on side and back
                doors for extra security. Make sure the lock is connected to
                your home automation system for easy monitoring and control.
              </p>
            )}
          </li>
          <li className="device-item">
            <div
              onClick={() => toggleTips("smokeAlarm")}
              className="device-toggle"
            >
              <div className="device-name">
                <span
                  className="device-icon"
                  style={{ backgroundColor: "#00ff00" }}
                ></span>
                <span>Smoke Alarm</span>
              </div>
              {showTips.smokeAlarm ? "^" : "v"}
            </div>
            {showTips.smokeAlarm && (
              <p className="device-description">
                Place on the ceiling in common areas to detect smoke early.
                Install in hallways outside sleeping areas and ensure it is
                tested monthly. Replace the batteries annually to ensure it is
                always functional.
              </p>
            )}
          </li>
          <li className="device-item">
            <div
              onClick={() => toggleTips("securityCamera")}
              className="device-toggle"
            >
              <div className="device-name">
                <span
                  className="device-icon"
                  style={{ backgroundColor: "#0000ff" }}
                ></span>
                <span>Security Camera</span>
              </div>
              {showTips.securityCamera ? "^" : "v"}
            </div>
            {showTips.securityCamera && (
              <p className="device-description">
                Install at entry points to monitor activity and deter intruders.
                Position cameras at multiple angles to cover blind spots and
                ensure footage is accessible remotely through your mobile
                device.
              </p>
            )}
          </li>
        </ul>
      </div>
      <div className="model-container">
        <FbxModel />
      </div>
      {showMapPrompt && <MapPrompt onClose={() => setShowMapPrompt(false)} />}{" "}
    </div>
  );
}

export default ModelPage;
